<mat-form-field class="plan-form">
    <app-select-search
        [placeholder]="'Plan'"
        [formControl]="planForm"
        [Options]="plans$ | async"
        [CompareOptions]="CompareByDocumentId"
    ></app-select-search>
    <fa-icon matSuffix icon="times" style="margin-left: 3px; cursor: pointer;" (click)="planForm.reset();$event.stopPropagation();" *ngIf="!planForm.disabled"></fa-icon>
</mat-form-field>
<div *ngIf="planForm.value as selectedPlan">
    <ng-container *ngFor="let plan of plans$ | async">
        <app-leaflet-wrapper *ngIf="CompareByDocumentId(plan, selectedPlan)" [ScreenshotButton]="true" (ScreenshotTaken)="onScreenshotTaken($event)" (MapInitialized)="setEventsInit(leafletMap, plan.documentId)" (MarkerAdded)="onMarkerAdded(leafletMap, plan.documentId)" (MarkerMoved)="onMarkerMoved(leafletMap, plan.documentId)" [InitialDocument]="plan" #leafletMap></app-leaflet-wrapper>
    </ng-container>
</div>
